import { render, staticRenderFns } from "./Fundamental_mobile.vue?vue&type=template&id=2c6b8969&scoped=true&"
import script from "./Fundamental_mobile.vue?vue&type=script&lang=js&"
export * from "./Fundamental_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Fundamental_mobile.vue?vue&type=style&index=0&id=2c6b8969&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b8969",
  null
  
)

export default component.exports